import store from "../store";
import { getSelectModel, getUserInviteInfo } from "@/api";
import { CHANNEL_CODE } from '@/consts/newConsts'

const { getState } = store;

// 是否vip用戶：vip_status 非 1 时按非会员上报 '2'；为 1 时按会员等级上报
// （会员等级映射：vip_type 1-旧会员/AI会员→'1'，2-基础AI会员→'3'，3-标准AI会员→'4'，4-高级AI会员→'5'）
// '1'-旧会员/AI会员；'2'-非会员；'3'-基础AI会员；'4'-标准AI会员；'5'-高级AI会员；
function isAIVipUser() {
  const userInfo = getState().app.userInfo;
  // 非会员上报 '2'
  if (userInfo?.vip_status !== 1) return '2';
  // 会员：从 vip_info 中筛选已开通的会员，取最高等级上报
  const vipTypeMap = { 1: '1', 2: '3', 3: '4', 4: '5' };
  const activeVips = (userInfo?.vip_info || []).filter(item => item.is_vip);
  if (activeVips.length === 0) return '2';
  const topVip = activeVips.reduce((max, item) => item.vip_type > max.vip_type ? item : max);
  return vipTypeMap[topVip.vip_type] || '1';
}

// room_id、pindao_id是否上报为0(在新版AI绘画orAI改图页面时，room_id、pindao_id上报为0)
function isReport0ID() {
  const _location = window.location.href;
  return _location.indexOf('/main/AIDraw') > -1 || _location.indexOf('/main/AIEdit') > -1;
}

function getCookieByName(name) {
  const cookies = document.cookie.split('; ');
  for (let i = 0; i < cookies.length; i++) {
    const [key, value] = cookies[i].split('=');
    if (key === name) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

// AI改图相关埋点
export function LlwAiChangeClick(obj = {
  change_action: '',  // 事件枚举  1-绘制页面展示；2-重新上传；3-删除图片；4-点击【开始改图】；5-上传图片；6-关闭；7-橡皮擦；9-撤销；10-清除
}) {
  window.$sensors.sensors.track('LlwAiChangeClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

// 新版AI改图相关埋点
export function LlwAiChangeClick02(obj = {
  change_tfunction: '', // 所选改图功能： 1-替换；2-擦除；3-改材质；4-超清放大；5-改颜色；6-替换风格；7-智能抠图；8-水印工具（去水印）；9-水印工具（加水印）
  change_action02: '', // 点击行为：1--点击【开始改图】；2-重新上传；3-上传图片；4-橡皮擦；5-重置；6-上一步；7-下一步；8-自动涂抹（自动擦除、AI抠物体）；9-手动涂抹（手动擦除、手动抠物体）；10-点击历史记录图片查看大图；11-历史记录小图点击下载；12-历史记录小图点击改图；13-复制指令；14-点击画布内小图；15-查看原图比对点击；16-保存改图记录；17-带水印下载；18-下载（去水印下载）；19-5K超清下载；20-展示改图界面（切换改图功能时需要重新上报）；21-上传图片精准替换后去抠图；22-智能去背景；23-擦除；24-保留；25-自动去水印；26-手动去水印
  suanli_balance: '' // 针对非会员，change_action02=17时上报，上报用户当前算力余额
}) {
  if (!obj.suanli_balance) delete obj.suanli_balance; // 针对非会员，change_action02=17时上报，上报用户当前算力余额
  window.$sensors.sensors.track('LlwAiChangeClick02', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser(),
  });
}

// 灵感图页面点击埋点
export function LlwAiInspirationClick(obj = {
  inspiration_action: '',  // 事件枚举 1-点击【创作同款】
  search_word: '', // 搜索词 模型曝光/点击页面为搜索结果页时，搜索词不能为空
  ll_id: '', // 素材ID 素材的llid
  position: 0, // 当前坑位
}) {
  window.$sensors.sensors.track('LlwAiInspirationClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

// 共创页面点击埋点
export function LlwAiGongchuangClick(obj = {
  gongchuang_click: '', //事件枚举 1-点击【创作同款】；2-点击【参与共创】；3-点击【发起共创】；4-点击banner广告
  search_word: '', //搜索词 模型曝光/点击页面为搜索结果页时，搜索词不能为空
  model_id: '', //模型ID gongchuang_click=1,2时上报模型的ID
  position: -1, //当前坑位 gongchuang_click=1,2时曝光坑位组，以坑位顺序上报，不受页码排序影响
}) {
  window.$sensors.sensors.track('LlwAiGongchuangClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

// 共创页面素材曝光埋点
export function LlwAiModelShow(obj = {
  model_id: '', // 模型ID 上报模型的ID
  search_word: '',// 搜索词 模型曝光/点击页面为搜索结果页时，搜索词不能为空
  position: [],// 当前坑位 曝光坑位组，以坑位顺序上报，不受页码排序影响
}) {
  window.$sensors.sensors.track('LlwAiModelShow', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

// 消息操作点击埋点
export function LlwAiMessagereply(obj = {
  reply_action: '', // 事件枚举  1-点赞；2-表情；3-消息回复；4-查看大图；5-点击模型快速跳转绘画
  room_id: '',  // 房间id  上报当前房间ID
  room_member_nums: 0,  // 当前房间人数
  pindao_id: '',   // 频道id
  ai_works_id: '',  // 作品id
  this_num: '', // 当前作品序号
  draw_all_nums: '', // 绘画张数
  draw_type: '' // 绘画类型 1-文生图 2-图生图
}) {
  window.$sensors.sensors.track('LlwAiMessagereply', {
    ...obj,
    room_id: isReport0ID() ? '0' : obj.room_id, // 新版AICO的room_id上报为0
    pindao_id: isReport0ID() ? '0' : obj.pindao_id, // 新版AICO的pindao_id上报为0
    room_member_nums: getState().app.serverUserNumObj[obj.room_id] || 0,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

// AI面板展示埋点
export function LlwAiAiShow(obj = {
  ai_show: "", // 事件枚举 1-绘画面板展示；2-共创面板展示；3-训练-正式版本展示；4-训练-训练版本展示；5-训练-新建训练展示；
  room_id: '', // 房间id  上报当前房间ID
  room_member_nums: 0, //房间内人数  上报当前房间内人数
  pindao_id: '', // 频道id  上报当前所在频道id
}) {
  const params = {
    ...obj,
    room_id: isReport0ID() ? '0' : obj.room_id, // 新版AICO的room_id上报为0
    pindao_id: isReport0ID() ? '0' : obj.pindao_id, // 新版AICO的pindao_id上报为0
    room_member_nums: getState().app.serverUserNumObj[obj.room_id] || 0,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  };
  if (+obj.ai_show === 1) { // 打开绘画面板时，需要传ab_test字段
    getSelectModel().then(res => {
      const groupId = res?.data?.group;
      params['ab_test'] = ['TPWL-7877' + '-' + groupId];
      window.$sensors.sensors.track('LlwAiAiShow', params);
    });
  } else {
    window.$sensors.sensors.track('LlwAiAiShow', params);
  }
}

//AI面板点击事件埋点
export function LlwAiAiClick(obj = {
  ai_click: '', //事件枚举  1-点击【设为正式模型】；2-点击【删除模型】；3-点击【修改模型描述】
  room_id: '', //房间id  上报当前房间ID
  room_member_nums: 0, //房间内人数
  channel_id: '', //频道ID 上报当前频道ID
}) {
  window.$sensors.sensors.track('LlwAiAiClick', {
    ...obj,
    room_id: isReport0ID() ? '0' : obj.room_id, // 新版AICO的room_id上报为0
    room_member_nums: getState().app.serverUserNumObj[obj.room_id] || 0,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

// 图片大图详情按钮点击埋点
export function LlwAiPicturedetail(obj = {
  picture_action: '', // 事件枚举  图片操作类型  1-点赞；2-表情；3-局部重绘；4-下载；5-查看比对；6-去绘画
  ai_works_id: '', // 作品ID   查看的是AI绘图作品时上报作品ID
  model_id: '', // 模型ID 查看的是训练图片时上报模型ID
  room_id: '', // 房间ID 上报当前房间ID
  room_member_nums: 0, // 房间内人数
  pindao_id: '', // 频道ID 上报当前频道ID
  this_num: '', // 当前作品序号
  draw_all_nums: '', // 绘画张数
  draw_type: '' // 绘画类型 1-文生图 2-图生图
}) {
  window.$sensors.sensors.track('LlwAiPicturedetail', {
    ...obj,
    room_id: isReport0ID() ? '0' : obj.room_id, // 新版AICO的room_id上报为0
    pindao_id: isReport0ID() ? '0' : obj.pindao_id, // 新版AICO的pindao_id上报为0
    room_member_nums: getState().app.serverUserNumObj[obj.room_id] || 0,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

//溜溜网素材曝光
export function LlwResExposure(obj = {
  algorithm_type: 0, //算法类型 0：默认值，1：搜索-火山实验组，2：搜索-自研对照组，3:搜索-自研组，4:搜索-火山B大流量，11：详情页推荐-自研新版，12：详情页推荐-自研旧版，13:图搜-自研组，14:图搜-第三方组，15:详情页推荐-自研对照组，16：详情页推荐-火山实验组，17：详情页推荐-默认分组，21：下了又下-自研新版，22：下了又下-自研旧版，31：h5-类目首页推荐新版，32：h5-类目首页推荐旧版，41：小程序-类目首页推荐新版，42：小程序-类目首页推荐旧版，51：分类列表页-搜索，52：分类列表页-推荐，53：分类列表页--默认分组
  algorithm_version: 0, //算法版本 如:1.0，由算法提供
  ab: 0, //算法分流
  action_id: '', //行为ID
  ll_id_arr: [], //素材ID  传入外部id组
  search_word: '', //搜索词   下载来源为：搜索列表页、普通列表页，访问来源页面搜索列表时，搜索词不能为空
  lsof_arr: [], //火山实时解密SOF组
  list_layout_type: '', //列表页布局类型 0：非普通/搜索列表页产生点击则上报，1：常规，2：横向瀑布流，3：纵向瀑布流
  page: '', //当前页码
  expo_num: 0, //素材曝光个数  本组上报的素材个数
  res_detail: '', //素材详情
}) {
  window.$sensors.sensors.track('LlwResExposure', {
    ...obj
  });
}


//溜溜网素材点击
export function LlwResClick(obj = {
  algorithm_type: 0, //算法类型 0：默认值，1：搜索-火山实验组，2：搜索-自研对照组，3:搜索-自研组，4:搜索-火山B大流量，11：详情页推荐-自研新版，12：详情页推荐-自研旧版，13:图搜-自研组，14:图搜-第三方组，15:详情页推荐-自研对照组，16：详情页推荐-火山实验组，17：详情页推荐-默认分组，21：下了又下-自研新版，22：下了又下-自研旧版，31：h5-类目首页推荐新版，32：h5-类目首页推荐旧版，41：小程序-类目首页推荐新版，42：小程序-类目首页推荐旧版，51：分类列表页-搜索，52：分类列表页-推荐，53：分类列表页--默认分组
  algorithm_version: 0, //算法版本 如:1.0，由算法提供
  ab: 0, //算法分流
  request_id: '', //算法ID
  action_id: '', //行为ID
  source_alg: 0, //推荐算法来源  推荐召回算法的来源，算法类型为推荐自研相关都会传入，其余情况传入0
  llw_source_scene: 0,//溜溜网来源场景  0：默认值，1：搜索列表页，2：详情页推荐，3：下载后推荐，4：普通列表页，5：类目首页，6：主站首页，7：合辑详情页，8：图搜列表页，9：分享，10：seo素材频道，11：收藏，12：新瀑布流首页，13：小程序，14：H5，15：移动端首页综合推荐，16：移动端首页同类推荐，17：移动端收藏综合推荐，18：移动端收藏同类推荐，19：暂无(可使用)， 20：溜溜AI
  pay_type: 0, //素材收费类型  0:免费，1:溜币，2精品，3vip
  ll_id: '', //素材ID  传入外部id组
  search_word: '', //搜索词   下载来源为：搜索列表页、普通列表页，访问来源页面搜索列表时，搜索词不能为空
  position: 0, //当前坑位    曝光坑位组，以坑位顺序上报，不受页码排序影响
  page: 0, //当前页码
  lsof: '', //火山实时解密SOF
  list_layout_type: '', //列表页布局类型 0：非普通/搜索列表页产生点击则上报，1：常规，2：横向瀑布流，3：纵向瀑布流
}) {
  window.$sensors.sensors.track('LlwResClick', {
    ...obj
  });
}

//新手指导
export function LlwAiteach(obj = {
  // ab_test: ['TPWL-6837' + '-' + obj.groupId],
  // teach_show: '',  //教学页展示  7-新教学第一步展示；8-新教学第二步展示；9-新教学第三步展示；10-新教学点击【开始绘画】按钮；11-点击【跳过引导】按钮；12-教学弹窗展示（MP4）
  // if_first: 1, //是否第一次展示新手教学   1-是；2-否
}) {
  window.$sensors.sensors.track('LlwAiteach', {
    if_first: 1,
    ...obj,
    ab_test: ['TPWL-6837' + '-' + obj.groupId],
    ai_source_2: getState().app.ai_source
  });
}

// 主要页面展示
export function LlwAiMainPageShow(obj = {
  main_page_show: '', // 主要页面展示：1-灵感页展示；2-服务器页面展示；3-共创页展示；4-绘画页-我的作品展示；5-绘画页-热门作品展示；6-改图页-未上传图片；7-改图页-已上传图片
  room_type: '', // 房间类型：main_page_show=2时上报当前所在房间类型：1-公开房间；2-私密房间
  room_id: '', // 房间ID：main_page_show=2时上报当前房间ID
  room_member_nums: 0, // 房间内人数
  model_id: '', // 模型ID: 生成图片的模型ID（当main_page_show=4或5时，上报当前的模型ID，切换模型时也要上报1次展示）
  change_tfunction: '' // 所选改图功能：1-替换；2-擦除；3-改材质；4-超清放大；5-改颜色（当main_page_show=6或7时，上报当前选中的改图功能，切换功能时也要上报1次展示）
}) {
  if (getState().app.userInfo) {
    // 获取用户当前的邀请信息
    getUserInviteInfo().then(res => {
      window.$sensors.sensors.track('LlwAiMainPageShow', {
        ...obj,
        ab_test: ['TPWL-9085-2'], // AB测分组：按tapd_id+group进行拼接，如TPWL-3996-1。如有多个实验交叉，则拼接多个实验分组信息上报，如["TPWL-3996-1","TPWL-4596-2"]
        room_id: isReport0ID() ? '0' : obj.room_id, // 新版AICO的room_id上报为0
        ai_source_2: getState().app.ai_source,
        if_ai_vip: isAIVipUser(),
        invite_nums: res.status === 200 ? res.data.trigger_user_num : null
      });
    });
  } else {
    // console.log('--------LlwAiMainPageShow上报--------')
    window.$sensors.sensors.track('LlwAiMainPageShow', {
      ...obj,
      ab_test: ['TPWL-9085-2'], // AB测分组：按tapd_id+group进行拼接，如TPWL-3996-1。如有多个实验交叉，则拼接多个实验分组信息上报，如["TPWL-3996-1","TPWL-4596-2"]
      room_id: isReport0ID() ? '0' : obj.room_id, // 新版AICO的room_id上报为0
      ai_source_2: getState().app.ai_source
    });
  }

}

//描述词统计
export function LlwAiCiku(obj = {
  ciku: '', //词库使用上报  1-词库弹窗展示；2-词库弹窗点击选择描述词；3-随机词填入描述词填写框
}) {
  window.$sensors.sensors.track('LlwAiCiku', {
    ...obj,
    ai_source_2: getState().app.ai_source
  });
}

// 作品管理页
export function LlwAiWorkManage(obj = {
  manage_action: '', // 主要行为  1-作品页展示-AI作品；2-作品页展示-重绘；3-点击复用指令绘制；4-点击重绘；5-点击删除；6-点击下载；7-点击图片查看大图；8-确认删除图片（二次确认弹窗）
  ai_works_id: '', // 作品ID  查看的是AI绘图作品时上报作品ID（切换图片展示时要上报新的ID）
  imgid: '', // 图片ID  上报当前查看图片的ID（切换图片展示时要上报新的ID）
}) {
  window.$sensors.sensors.track('LlwAiWorkManage', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

// 溜溜AI-主要点击
export function LlwAiMainPageClick(obj = {
  main_page_click: '', // 功能栏主要按钮点击
  // 9-点击首页立即生图；10-点击首页智能生图功能介绍-广告位1；11-点击首页换物体功能介绍-广告位2；12-点击首页细节增强功能介绍-广告位3；13-点击高清HD功能介绍-广告位4；
  // 16-生图框下方广告位点击；17-首页生图框-点去改图模式；18-功能介绍弹窗-点击上传图片；19-功能介绍弹窗-点击官方示例
  // 26-平面填彩点击

  /* 老版共创的字段不在上报
  room_type: '', // 房间类型  1-公开房间；2-私密房间
  room_id: '', // 房间ID  上报当前房间ID
  pindao_id: '', // 频道ID  上报当前频道ID
  pindao_function_draw: '', // 频道是否配置AI绘画功能  1-是；2-否
  pindao_function_train: '', // 频道是否配置训练功能 1-是；2-否
  pindao_function_change: '', // 频道是否配置改图功能 1-是；2-否
  room_member_nums: 0, // 房间内人数 上报当前房间内人数 **/
}) {
  window.$sensors.sensors.track('LlwAiMainPageClick', {
    ...obj,
    // room_id: isReport0ID() ? '0' : obj.room_id, // 新版AICO的room_id上报为0
    // pindao_id: isReport0ID() ? '0' : obj.pindao_id, // 新版AICO的pindao_id上报为0
    // room_member_nums: getState().app.serverUserNumObj[obj.room_id] || 0,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  });
}

// 会员充值-入口点击
export function LlwMemberLocationClick(obj = {
  is_recharge_xzb: false // 是否充值过下载币
}) {
  window.$sensors.sensors.track('LlwMemberLocationClick', {
    order_goods: 12, // 订单商品  12: 溜溜AI会员
    member_location: getState().app.memberLocation, // 会员充值入口
    is_recharge_vip: (getCookieByName('vip_array') || '').split(','), // 是否VIP首充
    llw_source_scene: 0, // 溜溜网素材曝光场景
    ...obj,
    ai_source_2: getState().app.ai_source
  });
}

// 会员充值-切换套餐
export function LlwMemberGoodsSelect(obj = {
  goods_id: '', // 订单号
  goods_name: '', // 订单名称
  asset_type: 1, // 主体类型 1：个人 2：企业
  is_recharge_xzb: false // 是否充值过下载币
}) {
  window.$sensors.sensors.track('LlwMemberGoodsSelect', {
    order_goods: 12, // 订单商品  12: 溜溜AI会员
    member_location: getState().app.memberLocation, // 会员充值入口
    is_recharge_vip: (getCookieByName('vip_array') || '').split(','), // 是否VIP首充
    ...obj,
    ai_source_2: getState().app.ai_source
  });
}

// 创建快捷方式弹窗
export function LlwAiShortcuts(obj = {
  shortcuts: '', // 1：弹窗展示 2：点击关闭按钮 3：点击保存到桌面 4:创建应用成功
  if_7days_choose: '' // 是否勾选7天内不再展示
}) {
  window.$sensors.sensors.track('LlwAiShortcuts', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  })
}

export function LlwAiWorkShow(obj = {
  workshow: '', // 作品展示 1-作品栏展示；2-点击图片查看大图；3-点击【画同款】按钮
  imgid: '', // 图片id
  room_id: '', // 房间id
  pindao_id: '', // 频道id
}) {
  window.$sensors.sensors.track('LlwAiWorkShow', {
    ...obj,
    room_id: isReport0ID() ? '0' : obj.room_id, // 新版AICO的room_id上报为0
    pindao_id: isReport0ID() ? '0' : obj.pindao_id, // 新版AICO的pindao_id上报为0
    ai_source_2: getState().app.ai_source,
  });
}

// 溜溜AI-无限画布主功能展示
export function LlwAiCanvasPageShow(obj = {
  canvas_function: '', // 生图，换物体，细节增强，高清HD。以字符串形式传入
}) {
  window.$sensors.sensors.track('LlwAiCanvasPageShow', {
    ...obj,
    ai_source_2: getState().app.ai_source,
  });
}

export const getImgSource = () => {
  const href = window.location.href
  if (href.indexOf('pro/Index') > -1) {
    return '1'
  }
  if (href.indexOf('pro/Canvas') > -1) {
    return '2'
  }
  if (href.indexOf('pro/workManagePage') > -1) {
    return '3'
  }
}

// 画布页点击
export function LlwAiCanvasPageClick(obj = {
  canvas_function: '', // string: 生图，换物体，细节增强，高清HD。以字符串形式传入
  canvas_core_click: null, // number 4：收藏，5：取消收藏，6：图片编辑， 9：高清HD，10：细节增强，11：画同款；12-图片详情页展示；13-带水印下载；14-去水印下载；
  //15-用作参考图；16-进入平铺比对；17-进入自由比对；18-快速比对；19-分享到首页 20-分享复制链接 21-作品管理确认删除 22-作品管理画同款（没有imgid）
  algorithm_model_type: '', // string 算法模型类型
  algorithm_model_id: null, // number 算法模型ID 用户自己上传的图片无需上传
  algorithm_model_name: '', // string 模型名称 用户自己上传的图片无需上传
  workflow_id: null, // number 工作流ID
  ai_works_id: '', // 作品id 用户自己上传的图片无需上传
  imgid: '', // 图片id 用户自己上传的图片无需上传
}) {
  window.$sensors.sensors.track('LlwAiCanvasPageClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser(),
    img_source_1: getImgSource(),
  });
}

// 无限画布版-开始改图
export function LlwAiEditImageClick(obj = {
  canvas_function: '', // 生图，换物体，细节增强，高清HD。以字符串形式传入
  suanli_balance: null, // number 算力余额
  draw_spend: null,  //算力花费
}) {
  window.$sensors.sensors.track('LlwAiEditImageClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    ai_render_port: getAIRenderPort(),
    if_ai_vip: isAIVipUser(),
  });
}

// 是否首次访问 AI改图 页面的 localStorage 缓存 key：首次显示引导时写入
export const AI_CHANGE_PIC_FIRST_VISIT_KEY = 'ai_change_pic_first_visit'

// 当前登录会话已完成 AI 改图新手引导判断的用户 ID
export const AI_CHANGE_PIC_GUIDE_SESSION_KEY = 'ai_change_pic_guide_checked_user'

// AI 首页搜索开始
export function LykMainPageSearchStart(obj = {
  ai_main_page_srearch_content: '',
  ai_search_task_id: '',
}) {
  window.$sensors.sensors.track('LykMainPageSearchStart', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  })
}

// AI 首页搜索完成
/**
 * @param {{
 *   ai_search_task_id?: string,
 *   ai_search_result?: string,
 *   ai_search_during?: string,
 *   ai_serach_tools_match?: Array<string | number>,
 *   ai_serach_prompt?: string,
 * }} obj
 */
export function LykMainPageSearchFinish(obj = {
  ai_search_task_id: '',
  ai_search_result: '',
  ai_search_during: '',
  ai_serach_tools_match: [],
  ai_serach_prompt: '',
}) {
  window.$sensors.sensors.track('LykMainPageSearchFinish', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  })
}

// AI 首页点击
export function LykMainPageClick(obj = {
  ai_funtcion_click: '',
  ai_serach_prompt: '',
  ai_search_task_id: '',
  is_rencent_use_click: ''
}) {
  window.$sensors.sensors.track('LykMainPageClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  })
}

// 新版本页面展示
export function LlwAiMainPageShownew(obj = {
  main_page_show_1: '', // 1-首页；2-画布页；3-工具集页面；4-作品页；5-弹窗引导；6-PS插件导流弹窗主动弹出；
  // 7-插件常驻导流浮窗展示；8-涂抹改图引导弹窗展示；9-AI渲染；10-AI改图
  is_first_visit: '', // 是否首次访问当前页面 1：是；2：否 ， 目前只有 10-AI改图
}) {
  window.$sensors.sensors.track('LlwAiMainPageShownew', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  })
}

// 首页推荐素材曝光
export function LlwAiHomePageShow(obj = {
  img_detail: '', // json 字符串  上报当前页面曝光图片详细信息的对象数组，包括ID、位置、分类信息。上报素材的详情信息对象数组：imgid(string),position(number),classify(string:作品类别)
}) {
  window.$sensors.sensors.track('LlwAiHomePageShow', {
    ...obj,
    ai_source_2: getState().app.ai_source,
  })
}

// 首页推荐素材点击
export function LlwAiHomePageClick(obj = {
  homepage_click: '', // 1-点击图片；2-点击【画同款】
  imgid: '', // 当前操作图片的ID
  position: null,
}) {
  window.$sensors.sensors.track('LlwAiHomePageClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
  })
}

// 图片大图查看页面行为
export function LlwAiPicturedetailNew(obj = {
  picture_action_new: '', // 1-图片详情页展示；2-带水印下载；3-去水印下载；4-高清HD；5-细节增强；6-改图；7-用作参考图；
  // 8-画同款；9-进入平铺比对；10-进入自由比对；11-分享到首页；12-分享复制链接
  imgid: '', // 当前操作图片的ID
  img_source: '', // 1-首页热门推荐；2-画布；3-作品页
}) {
  window.$sensors.sensors.track('LlwAiPicturedetailNew', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    if_ai_vip: isAIVipUser()
  })
}

// 工具集工具曝光
export function LlwAiToolShow(obj = {
  tool_detail: '', // json 字符串 上报当前页面曝光图片详细信息的对象数组，包括ID、位置。上报素材的详情信息对象数组：toolid-str,position-num
}) {
  window.$sensors.sensors.track('LlwAiToolShow', {
    ...obj,
    ai_source_2: getState().app.ai_source,
  })
}

// 工具集工具点击
export function LlwAiToolClick(obj = {
  tool_click: '', // 1-点击工具
  toolid: '', // 工具id
  position: null, // 工具位置
}) {
  window.$sensors.sensors.track('LlwAiToolClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
  })
}

// 画布主功能点击
export function LlwAiCanvasFunctionClick(obj = {
  canvas_function: '', // 生图，换物体，细节增强，高清HD。以字符串形式传入
  canvas_function_click: '', // 1-编辑项目名称；2-切换项目（包括新建和查看所有项目）；3-点击教学；4-点击历史记录；5-点击收藏夹；6-收藏夹点击上传本地图片；
  // 7-改图/画图点击快捷参考词； 8-点击智能选区；9-点击套索工具；10-点击画笔（进入改图默认选中不用上报）；11-点击橡皮；12-在历史记录或者收藏夹拖拽图片使用；
  // 13-使用历史描述词；14-点击智能描述词；15-画图主动切换模型；16-改图主动切换模型；17-在画布上拖拽图片使用；18-右上角上传图片；
}) {
  window.$sensors.sensors.track('LlwAiCanvasFunctionClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
  })
}

//  溜溜AI算力充值页面展示
export function LlwAiSuanliShow(obj = {
  canvas_function: '',
  is_recharge_suanli: false, // 是否充值过算力
  is_recharge_xzb: false, // 是否充值过下载币
  suanli_balance: null, // 算力余额
}) {
  window.$sensors.sensors.track('LlwAiSuanliShow', {
    member_location: getState().app.memberLocation, // 会员充值入口
    is_recharge_vip: (getCookieByName('vip_array') || '').split(','), // 是否VIP首充
    if_ai_vip: isAIVipUser(),
    ai_source_2: getState().app.ai_source,
    ...obj,
  });
}

// AI 转化策略弹窗曝光：1-常规转化策略，2-统一转化策略，3-AI 充值福利。
export function AIZhuanhuacelueExposure(type) {
  window.$sensors.sensors.track('AIZhuanhuacelueExposure', {
    AI_zhuanhua_exposure_type: type,
  });
}


// ------------------AI 渲染---------------------

const getAIRenderPort = () => { // 1-SU插件 2-MAX插件 3-溜溜AI网页
  const source = getState().app.ai_source;
  if (source === CHANNEL_CODE.SU) return 1;
  if (source === CHANNEL_CODE.MAX) return 2;
  return 3;
}

// 用户点击开始生图
export function LykAIRenderWorkStart(obj = {
  ai_render_type: null, // 1-截取视图  2-使用相机 3-上传
  ai_render_num: 1, // 截图数量
  ai_render_style_type: '',
  ai_render_light_type: null, // 0-未选择 1-自然光 2-自然+灯光 3-:1+2
  ai_render_out_res: '', // 1k 2k 3k
  balance_situation: null, // 1-充足 2-不足
}) {
  window.$sensors.sensors.track('LykAIRenderWorkStart', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    ai_render_port: getAIRenderPort()
  })
}

// 用户点击按钮时上报
export function LykAIRenderClick(obj = {
  ai_render_buttom_click: null,  //1-下载 2-AI改图 3-高清放大 4-查看详情 5-发送到PS 6-再次生成 7-去AI改图 12-使用该配置(精细渲染场景参数) 14-加入模板
  ai_render_click_position: null, // 1-主页面 2-图片详情
}) {
  window.$sensors.sensors.track('LykAIRenderClick', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    ai_render_port: getAIRenderPort()
  })
}

// 图片下载
export function LlwAiImgDownload(obj = {
  canvas_function: '',
}) {
  window.$sensors.sensors.track('LlwAiImgDownload', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    ai_render_port: getAIRenderPort()
  })
}

// AI改图新手引导
export function LykAIEditOnBoardingViewed(obj = {
  on_boarding_done: null, // 引导是否完成 1-完成；2-跳过
  on_boarding_skip_step: null, //跳过处在的步骤 1-第一步；2-第二步；3-第三步；4-第四步 5-第五步
}) {
  window.$sensors.sensors.track('LykAIEditOnBoardingViewed', {
    ...obj,
    ai_source_2: getState().app.ai_source,
  })
}

// AI改图发起任务
export function LykAIEditWorkStart(obj = {
  ai_edit_function_type: '', // AI改图功能类型-一级tab  室内设计；建筑设计；通用功能
  ai_edit_function_type2: '', // AI改图功能类型-二级tab  替换物体；添加物体；消除物体；智能修改；场景编辑；高清放大；细节增强；效果图美化；去水印
  ai_edit_function_type3: '', // AI改图功能类型-三级tab  替换软装；替换硬装；替换物体颜色；替换物体材质；文字改图；图片改图；替换建筑立面；场地建筑融合
  ai_edit_reference_type: null, // AI改图参考图类型  1：本地上传；2：官方图库；3：无参考图
  ai_edit_prompt: '', // AI改图提示词内容  用户输入的完整字符串
  ai_render_out_res: '', // 输出分辨率选择分辨率  1K\2K\4K
  ai_edit_model: '', // AI改图选择模型  模型名称
  is_first_edit_work: null, // 是否首次使用当前功能  1：是；2：否（需要通过三级组合来判断）
  is_first_visit: '', // 是否首次访问当前页面  1：是；2：否
  ai_edit_base_source: null, // Ai改图底图来源  1：本地上传；2：AI渲染生成结果；3：AI改图生成结果；4：AI生图生成结果
}) {
  window.$sensors.sensors.track('LykAIEditWorkStart', {
    ...obj,
    ai_source_2: getState().app.ai_source,
  })
}



// 溜溜AI充值页面展示
export function LlwAiRechargeShow(obj = {
  canvas_function: '',
}) {
  window.$sensors.sensors.track('LlwAiRechargeShow', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    is_recharge_vip: (getCookieByName('vip_array') || '').split(','), // 是否VIP首充
    if_ai_vip: isAIVipUser()
  })
}

// 推敲任务发起
export function LlwSchemeDeliberationStart(obj = {
  ai_render_type: null,  // 截图方式 1-截取视图  2-使用相机 3-上传
  ai_render_num: null, // 截图数量
  ai_render_out_res: '', // 输出分辨率 1k 2k 4k
  balance_situation: null, // 余额情况 1-充足 2-不足
}) {
  window.$sensors.sensors.track('LlwSchemeDeliberationStart', {
    ...obj,
    ai_source_2: getState().app.ai_source,
    ai_render_port: getAIRenderPort()
  })
}
